//@flow
import React, {useEffect} from 'react';
import {Autocomplete} from '@material-ui/lab';
import {useFormContext} from 'react-hook-form';

import FormField from '../../FormField';
import CustomButton from '../../../../../../elements/CustomButton/CustomButton';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {BLOG_FORM_FIELDS} from '../../../../constants';
import {
  useBlogCategories,
  useBlogCategoriesModal,
} from '../../../../utils/blog-category';

import type {BlogCategory} from '../../../../../../entities';
import {useBlogFormDraftValue} from '../../../../utils/blog-post';

export default function CategoriesField() {
  const categories = useBlogCategories();

  const {register, setValue, watch, errors, clearErrors} = useFormContext();
  const {updateDraft} = useBlogFormDraftValue();

  useEffect(() => {
    register(BLOG_FORM_FIELDS.categories, {
      required: 'Selecciona al menos una categoría',
    });
  }, [register]);

  const {openModal} = useBlogCategoriesModal();

  const handleSelectCategory = (categories: BlogCategory[]) => {
    setValue(BLOG_FORM_FIELDS.categories, categories);
  };

  const categoriesValue: BlogCategory[] = watch(
    BLOG_FORM_FIELDS.categories,
    []
  );

  return (
    <FormField
      title="3. Categoría"
      subtitle="Selecciona la categoría a la que pertenece tu entrada. Puede tener
    una o más categorías."
      contentRight={
        <CustomButton variant="outlined" onClick={openModal}>
          + Crear categoría
        </CustomButton>
      }
    >
      <Autocomplete
        onChange={(event, newValue) => {
          handleSelectCategory(newValue);
          clearErrors(BLOG_FORM_FIELDS.categories);
          updateDraft({[BLOG_FORM_FIELDS.categories]: newValue});
        }}
        multiple
        options={categories}
        value={categoriesValue}
        getOptionLabel={option => option.name}
        noOptionsText="Categoría no encontrada"
        renderInput={params => {
          return (
            <CustomTextField
              {...params}
              name="categories"
              type="text"
              helperText={errors.categories ? errors.categories.message : ''}
              error={!!errors.categories}
            />
          );
        }}
      />
    </FormField>
  );
}
